export default __webpack_public_path__ + "static/media/add_to_team.de9f2c99.jpg";